import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Account } from './account.types';
import Type = Account.Type;

@Pipe({
  name: 'appAccountTranslate'
})
export class AccountTranslatePipe implements PipeTransform {
  constructor(private translationService: TranslateService) {}

  public transform(accountType: Account.Type, textPublisher: string, textAdvertiser: string): string {
    return accountType === Type.PUBLISHER
      ? this.translationService.instant(textPublisher)
      : this.translationService.instant(textAdvertiser);
  }
}
